module.exports = __webpack_public_path__ + "static/media/send.59886b02.svg";